export default {
  title: 'Projects',
  projectManager: 'Project Manager',
  myCurrentProjects: 'My current projects',
  history: 'History',
  noCurrentProjects: 'No current projects',
  errorLoadingProjects: 'Error loading projects',
  freelancerProjectHistory: 'Completed projects',
  projectInformation: 'Project Information',
  projectName: 'Project Name',
  priceRange: 'Budget',
  dueDate: 'Due Date',
  startDate: 'Start Date',
  location: 'Location',
  team: 'Team',
  withClient: 'With {{name}}',
  jobOfferDescription: 'Job Offer Description',
  noDescriptionProvided: 'No description provided.',
  mySubmission: 'My Submission',
  viewAcceptedSubmission: 'View my accepted submission',
  viewSubmission: 'View submission',
  yourAlliances: 'Your Alliances',
  offer: 'Offer',
  serviceProvider: 'Service Provider',
  projectStatus: 'Project Status',
  inProgress: 'In Progress',
  completed: 'Completed',
  cancelled: 'Cancelled',
  changeStatus: 'Change Status',
  statusChangeConfirmation: 'Project Status',
  statusChangeMessage: 'You want to change the project status to',
  projectStatusChanged: 'The project status has been changed.',
  statusChangeNotification: 'All project participants will be notified.',
  cancelAndReturn: 'Return to Project Manager',
  confirm: 'Confirm',
  grandTotal: 'Grand Total',
  myJobOffer: 'My Job Offer',
  viewMyJobOffer: 'View My Job Offer',
  biddingSubmissions: "Freelancer's Submissions",
  description: 'Description',
  status: 'Status',
  date: 'Date',
  alliances: 'Alliances',
  submission: 'Submission',
  actions: 'Actions',
  evaluate: 'Evaluate',
  publicationDate: 'Publication Date',
  genericErrorUpdatingStatus:
    'An unknown error occurred while updating the project status. Please try again or contact support.',
  noPastProjects: 'No past projects',
  loadMore: 'Load more results',
  originalJobOffer: 'Original job offer',
  projectDescription: 'Project description',
  requestedProjectDeadline: 'Project deadline',
  requestedStartDate: 'Start date',
  serviceType: 'Required service types',
  viewJobOffer: 'View job offer',
  onSite: 'On-site work',
  budget: 'Budget',
  languages: 'Spoken language(s)',
  close: 'Close',
} as const;
